import React from 'react';
import type { BrandIconProps } from '.';
import { BrandIconDefaultSize } from '.';

export const Pinterest = React.forwardRef(
  ({ size = BrandIconDefaultSize, ...props }: BrandIconProps, svgRef: React.Ref<SVGSVGElement>) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        ref={svgRef}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.0007 2.00134C17.5228 2.00134 22 6.47813 22 12.0007C22 17.5232 17.5234 22 12.0007 22C10.9698 22 9.97503 21.8437 9.04033 21.5539C9.44759 20.8895 10.0571 19.801 10.2828 18.9329C10.4043 18.4648 10.9057 16.5556 10.9057 16.5556C11.2315 17.1773 12.1843 17.7035 13.1971 17.7035C16.2128 17.7035 18.386 14.9302 18.386 11.4831C18.386 8.1803 15.6887 5.70818 12.2217 5.70818C7.906 5.70818 5.61463 8.60501 5.61463 11.7583C5.61463 13.2247 6.39511 15.0504 7.64428 15.6321C7.83389 15.7202 7.9347 15.6815 7.9781 15.4992C8.01148 15.3596 8.1804 14.6805 8.25584 14.3646C8.27988 14.2631 8.26853 14.177 8.18641 14.0775C7.77313 13.5766 7.44198 12.6551 7.44198 11.7957C7.44198 9.59065 9.11176 7.45643 11.9566 7.45643C14.4135 7.45643 16.1334 9.13055 16.1334 11.5239C16.1334 14.2297 14.7674 16.1035 12.9901 16.1035C12.0087 16.1035 11.2736 15.2915 11.5093 14.2965C11.791 13.1072 12.3372 11.825 12.3372 10.9669C12.3372 10.199 11.9246 9.5586 11.072 9.5586C10.0685 9.5586 9.26265 10.5963 9.26265 11.9866C9.26265 12.8721 9.56176 13.4711 9.56176 13.4711C9.56176 13.4711 8.57097 17.6621 8.38937 18.4421C8.18841 19.3055 8.26786 20.5195 8.35532 21.3109C4.6352 19.8538 2 16.2357 2 11.9993C2 6.47679 6.47657 2 11.9993 2"
          fill="#E60023"
        />
      </svg>
    );
  }
);
